import React from 'react';
import { Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-slate-100 pt-16 pb-8" data-id="element-54">
      <div className="container mx-auto px-6" data-id="element-55">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-56">
          <div className="col-span-1 md:col-span-1" data-id="element-57">
            <a href="https://keyanalyzer.com/" className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-blue-600 mb-4 block" data-id="element-58">
              Keyanalyzer
            </a>
            <p className="text-slate-500 text-sm leading-relaxed mb-6" data-id="element-59">
              Helping you discover and choose the best software tools for your
              business needs. Visit{' '}
              <a href="https://keyanalyzer.com/" className="text-blue-600 hover:underline" data-id="element-60">
                Keyanalyzer.com
              </a>{' '}
              for more reviews.
            </p>
            <div className="flex gap-4" data-id="element-61">
              <a href="#" className="text-slate-400 hover:text-slate-900 transition-colors" data-id="element-62">
                <Twitter className="w-5 h-5" data-id="element-63" />
                <span className="sr-only" data-id="element-64">Twitter</span>
              </a>
              <a href="#" className="text-slate-400 hover:text-slate-900 transition-colors" data-id="element-65">
                <Linkedin className="w-5 h-5" data-id="element-66" />
                <span className="sr-only" data-id="element-67">LinkedIn</span>
              </a>
              <a href="#" className="text-slate-400 hover:text-slate-900 transition-colors" data-id="element-68">
                <Github className="w-5 h-5" data-id="element-69" />
                <span className="sr-only" data-id="element-70">GitHub</span>
              </a>
            </div>
          </div>

          <div data-id="element-71">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-72">Product</h4>
            <ul className="space-y-2 text-sm text-slate-600" data-id="element-73">
              <li data-id="element-74">
                <a href="https://keyanalyzer.com/" className="hover:text-blue-600 transition-colors" data-id="element-75">
                  Features
                </a>
              </li>
              <li data-id="element-76">
                <a href="https://keyanalyzer.com/" className="hover:text-blue-600 transition-colors" data-id="element-77">
                  Pricing
                </a>
              </li>
              <li data-id="element-78">
                <a href="https://keyanalyzer.com/" className="hover:text-blue-600 transition-colors" data-id="element-79">
                  Tool Directory
                </a>
              </li>
              <li data-id="element-80">
                <a href="https://keyanalyzer.com/" className="hover:text-blue-600 transition-colors" data-id="element-81">
                  Comparisons
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-82">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-83">Company</h4>
            <ul className="space-y-2 text-sm text-slate-600" data-id="element-84">
              <li data-id="element-85">
                <a href="https://keyanalyzer.com/about" className="hover:text-blue-600 transition-colors" data-id="element-86">
                  About Us
                </a>
              </li>
              <li data-id="element-87">
                <a href="https://keyanalyzer.com/careers" className="hover:text-blue-600 transition-colors" data-id="element-88">
                  Careers
                </a>
              </li>
              <li data-id="element-89">
                <a href="https://keyanalyzer.com/blog" className="hover:text-blue-600 transition-colors" data-id="element-90">
                  Blog
                </a>
              </li>
              <li data-id="element-91">
                <a href="https://keyanalyzer.com/contact" className="hover:text-blue-600 transition-colors" data-id="element-92">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-93">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-94">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-600" data-id="element-95">
              <li data-id="element-96">
                <a href="https://keyanalyzer.com/privacy" className="hover:text-blue-600 transition-colors" data-id="element-97">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-98">
                <a href="https://keyanalyzer.com/terms" className="hover:text-blue-600 transition-colors" data-id="element-99">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-100">
                <a href="https://keyanalyzer.com/cookie" className="hover:text-blue-600 transition-colors" data-id="element-101">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-102">
          <p className="text-sm text-slate-500" data-id="element-103">
            © {new Date().getFullYear()}{' '}
            <a href="https://keyanalyzer.com/" className="hover:underline" data-id="element-104">
              Keyanalyzer
            </a>
            . All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500" data-id="element-105">
            <a href="https://keyanalyzer.com/privacy" className="hover:text-slate-900" data-id="element-106">
              Privacy
            </a>
            <a href="https://keyanalyzer.com/terms" className="hover:text-slate-900" data-id="element-107">
              Terms
            </a>
            <a href="https://keyanalyzer.com/sitemap" className="hover:text-slate-900" data-id="element-108">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
}